export const PAGINATION = {
  page: 1,
  size: 10,
}

export const TASK_BELONG_OPTIONS = [
  { label: '新人任务', value: 'NEW_USER_TASK' },
  { label: '限时任务', value: 'LIMITED_TIME_TASK' },
]

export const TASK_BELONG_MAP = TASK_BELONG_OPTIONS.reduce((result, item) => {
  result[item.value] = item.label
  return result
}, {})

export const TASK_TYPE_OPTIONS = [
  { label: '单规则任务', value: 'SINGLE_RULE' },
  { label: '打卡型', value: 'CHECK_IN' },
  { label: '累计型', value: 'CUMULATIVE' },
]

export const TASK_TYPE_MAP = {
  SINGLE_RULE: '单规则任务',
  CHECK_IN: '打卡型',
  CUMULATIVE: '累计型',
}

export const TASK_STATUS_OPTIONS = [
  { label: '待领取任务', value: 'WAIT_RECEIVE_TASK' },
  { label: '进行中', value: 'IN_PROGRESS' },
  { label: '已过期', value: 'EXPIRED' },
  { label: '待领取奖励', value: 'WAIT_RECEIVE_REWARD' },
  { label: '已完成', value: 'COMPLETED' },
  { label: '已下线', value: 'OFFLINE' },
]

export const TASK_STATUS_MAP = TASK_STATUS_OPTIONS.reduce((result, item) => {
  result[item.value] = item.label
  return result
}, {})

/** 用户任务状态标签：type 对应 el-tag */
export const TASK_STATUS_TAG = {
  WAIT_RECEIVE_TASK: { text: '待领取任务', type: 'warning' },
  IN_PROGRESS: { text: '进行中', type: 'success' },
  EXPIRED: { text: '已过期', type: 'danger' },
  WAIT_RECEIVE_REWARD: { text: '待领取奖励', type: 'warning' },
  COMPLETED: { text: '已完成', type: 'success' },
  OFFLINE: { text: '已下线', type: 'info' },
}
